import React, { useRef } from 'react';
import styles from '../../styles/formComponent/SwitchComponent.module.scss';

const SwitchComponent = ({
  label,
  name,
  checked = false,
  onChange,
  onBlur,
  onFocus,
  required = false,
  disabled = false,
  error,
  helperText,
  size = 'medium',
  color = 'primary',
  description,
  className = '',
  value,
  readOnly = false,
  ...props
}) => {
  const switchRef = useRef(null);

  const handleChange = (e) => {
    if (!readOnly && onChange) {
      onChange(e);
    }
  };

  const handleFocus = (e) => {
    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e);
    }
  };

  const handleLabelClick = () => {
    if (!disabled && !readOnly && switchRef.current) {
      switchRef.current.click();
    }
  };

  const getWrapperClasses = () => {
    let classes = `${styles.switchWrapper}`;
    if (size === 'small') classes += ` ${styles.small}`;
    if (size === 'large') classes += ` ${styles.large}`;
    if (disabled) classes += ` ${styles.disabled}`;
    if (readOnly) classes += ` ${styles.readOnly}`;
    if (color === 'success') classes += ` ${styles.success}`;
    if (color === 'warning') classes += ` ${styles.warning}`;
    if (className) classes += ` ${className}`;
    return classes;
  };

  const getSwitchTrackClasses = () => {
    let classes = styles.switchTrack;
    if (checked) classes += ` ${styles.checked}`;
    if (error) classes += ` ${styles.error}`;
    if (disabled) classes += ` ${styles.disabled}`;
    if (readOnly) classes += ` ${styles.readOnly}`;
    return classes;
  };

  const getSwitchThumbClasses = () => {
    let classes = styles.switchThumb;
    if (checked) classes += ` ${styles.checked}`;
    if (disabled) classes += ` ${styles.disabled}`;
    if (readOnly) classes += ` ${styles.readOnly}`;
    return classes;
  };

  const getLabelClasses = () => {
    let classes = styles.label;
    if (disabled) classes += ` ${styles.disabled}`;
    if (readOnly) classes += ` ${styles.readOnly}`;
    if (error) classes += ` ${styles.error}`;
    return classes;
  };

  const getDescriptionClasses = () => {
    let classes = styles.description;
    if (disabled) classes += ` ${styles.disabled}`;
    if (readOnly) classes += ` ${styles.readOnly}`;
    return classes;
  };

  return (
    <div className={getWrapperClasses()}>
      <div className={styles.switchContainer}>
        <input
          ref={switchRef}
          type="checkbox"
          name={name}
          checked={checked}
          onChange={handleChange}
          onClick={(e) => readOnly && e.preventDefault()}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={disabled}
          required={required}
          className={styles.switch}
          value={value}
          aria-readonly={readOnly}
          {...props}
        />
        <div className={getSwitchTrackClasses()}>
          <div className={getSwitchThumbClasses()} />
        </div>
      </div>
      
      {(label || description) && (
        <div className={styles.labelContainer} onClick={handleLabelClick}>
          {label && (
            <label className={getLabelClasses()}>
              {label}
              {required && <span style={{ color: '#dc2626' }}> *</span>}
            </label>
          )}
          {description && (
            <div className={getDescriptionClasses()}>
              {description}
            </div>
          )}
        </div>
      )}
      
      {error && (
        <div className={styles.errorMessage}>{error}</div>
      )}
      {helperText && !error && (
        <div className={styles.helperText}>{helperText}</div>
      )}
    </div>
  );
};

export default SwitchComponent; 